import React, { useEffect, useState } from "react";
import { useGuidedTour } from "@/lib/guidedTour";
import { useNarrationCue } from "@/components/clientDemo/tour/TourCuePointer";
import { CalendarCard, CampusPulseCard, IncidentCard, WorkReadyCard } from "./SanctuaryCards";

export const SANCTUARY_CUES = [
  { phrase: "Incidents are filed", target: "exchange-sanctuary-card-incidents" },
  { phrase: "Work-Ready board", target: "exchange-sanctuary-card-workready" },
  { phrase: "campus calendar", target: "exchange-sanctuary-card-calendar" },
  { phrase: "campus pulse", target: "exchange-sanctuary-card-pulse" },
];
const CARDS = [IncidentCard, WorkReadyCard, CalendarCard, CampusPulseCard];

// Beat 04 — Sanctuary & Campus Operations; each card replays when the narration names it.
export default function ExchangeSanctuarySection() {
  const { isActive, current } = useGuidedTour();
  const live = isActive && current?.id === "beat04";
  const cue = useNarrationCue(SANCTUARY_CUES.map((c) => c.phrase), live);
  const [runs, setRuns] = useState([0, 0, 0, 0]);
  useEffect(() => {
    if (cue >= 0) setRuns((r) => r.map((n, i) => (i === cue ? n + 1 : n)));
  }, [cue]);

  return (
    <section data-testid="exchange-sanctuary-section" className="mt-8 rounded-3xl border border-[#D4AF37]/20 bg-[#0A0612] p-6 md:p-8">
      <div className="mb-6">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#C9A227]">// 07 · Operations</div>
        <h2 className="mt-1 text-2xl md:text-3xl font-extrabold tracking-tight text-white">Sanctuary &amp; Campus Operations</h2>
      </div>
      <div className="flex gap-6">
        <div className="flex-1 min-w-0 grid grid-cols-1 md:grid-cols-2 gap-4">
          {CARDS.map((Card, i) => <Card key={i} run={runs[i]} active={live && cue === i} />)}
        </div>
        <aside data-testid="exchange-sanctuary-dock" className="hidden xl:flex w-[440px] shrink-0 rounded-2xl border border-dashed border-[#D4AF37]/25 bg-[#D4AF37]/[0.03] p-6 flex-col justify-center">
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#C9A227]">One dashboard, every campus</div>
          <ul className="mt-4 space-y-3 text-sm text-slate-300">
            {["Incidents filed in seconds, leadership texted", "Weekly compliance & Work-Ready clearance", "Shifts, sessions and bookings in one calendar", "Live beds, residents and incidents per house"].map((t) => (
              <li key={t} className="flex items-start gap-2"><span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" />{t}</li>
            ))}
          </ul>
        </aside>
      </div>
    </section>
  );
}
